<template>
	<a-form
		:form="form"
		:label-col="{ span: 4 }"
		:wrapper-col="{ span: 20 }"
		@submit="handleForm"
		class="p-2"
	>
		<a-row>
			<a-col>
				<a-form-item label="Nombre">
					<a-input
						v-decorator="[
							'name',
							{
								rules: [
									{
										required: true,
										message: 'Campo requerido',
									},
								],
							},
						]"
						placeholder=""
					/>
				</a-form-item>
			</a-col>
		</a-row>

		<a-form-item :wrapper-col="{ offset: 4 }">
			<a-button
				type="primary"
				html-type="submit"
				:loading="loading"
				class="mr-2"
			>
				Agregar
			</a-button>
		</a-form-item>
	</a-form>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'AccountGroupCreate',
	data: function() {
		return {
			form: this.$form.createForm(this),
			loading: false,
		}
	},
	created() {
		this.loadAccountTypeList()
	},
	methods: {
		handleForm(e) {
			e.preventDefault()
			this.form.validateFields((err, values) => {
				if (!err) {
					this.loading = true
					this.createGroup({
						name: values.name,
					})
						.then(group => {
							this.form.resetFields()
							this.$emit('success', group)
						})
						.finally(() => {
							this.loading = false
						})
				}
			})
		},
		...mapActions({
			createGroup: ACTIONS.ACCOUNT_GROUP.CREATE,
			loadAccountTypeList: ACTIONS.ACCOUNT_TYPE.LIST,
		}),
	},

	computed: {
		...mapGetters(['getCurrentUser', 'getAccountTypeList']),
	},
}
</script>

<style></style>
